import React ,{useEffect} from 'react';
import AOS from 'aos';
import Header from '../Components/Shared/Header/Header';
import Banner from '../Components/Pages/Home/Banner';
import Services from '../Components/Pages/Home/Services';
import Testimonial from '../Components/Shared/Testimonial/Testimonial';
import Features from '../Components/Pages/Home/Features';
import Design from '../Components/Pages/Home/Design';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
import Communication from '../Components/Pages/Home/Communication';
import InnovativePart from '../Components/Pages/Home/Innovative';
import TabContainer from '../Components/Pages/Home/TabContainer';
import Blogs from '../Components/Shared/BlogsSection/Blogs';
import Slider from '../Components/Shared/LogoSlider/Slider';
import { images } from '../Components/Pages/Home/data';
import Bg from '../Assets/Cards/designDashboard.webp';
function Home(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header />
        <Banner />
        <Slider 
        list={images}
        />
        <Services />
        <Communication />
        <Testimonial />
        <TabContainer />
        <InnovativePart />
    <Features />
        <Design backgroundImage={Bg}
        title="Design, test and ship amazing products at scale with HostDesign"
        desc="HostDesign Enterprise transforms your design process, leading to better products, faster"
        />
        <Blogs />
        <Start />
        <Footer />
        </>
    )
}
export default Home ;
